import { Component } from '@angular/core';
import { MasterComponent, MasterDetailComponent, PanelComponent } from '@rocksoft/cdk';
import { DevicesUnavailableContainerComponent } from '../devices-unavailable/devices-unavailable.container';

@Component({
  selector: 'era-unavailable-devices',
  templateUrl: './unavailable-devices.component.html',
  styleUrls: ['./unavailable-devices.component.scss'],
  imports: [MasterDetailComponent, MasterComponent, PanelComponent, DevicesUnavailableContainerComponent],
})
export class UnavailableDevicesComponent {}
